import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M145 285C67.8 285 5 222.2 5 145S67.8 5 145 5s140 62.8 140 140-62.8 140-140 140zm0-269.4c-71.4 0-129.4 58-129.4 129.4s58 129.4 129.4 129.4 129.4-58 129.4-129.4S216.4 15.6 145 15.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.9 216.2l-66.1-55.4 10.9-13 54 45.3 102-103.8 12.2 11.9z"
})), 'CheckmarkCircleThinIcon');